function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useRef } from 'react';
import { UnorderedList, ListItem } from '@tapresearch/ui/components';
import { useToast as useChakraToast } from '@tapresearch/ui/hooks';
export var useToast = function() {
    var _toast = useChakraToast();
    var toast = useRef(function(id) {
        var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _param_status = _param.status, status = _param_status === void 0 ? 'info' : _param_status, _param_duration = _param.duration, duration = _param_duration === void 0 ? 4000 : _param_duration, _param_position = _param.position, position = _param_position === void 0 ? 'top' : _param_position, description = _param.description, _param_listItems = _param.listItems, listItems = _param_listItems === void 0 ? [] : _param_listItems, listProps = _param.listProps, rest = _object_without_properties(_param, [
            "status",
            "duration",
            "position",
            "description",
            "listItems",
            "listProps"
        ]);
        if (!_toast.isActive(id)) {
            var _TOAST_DEFAULTS_id;
            _toast(_object_spread(_object_spread_props(_object_spread({
                id: id,
                status: status,
                duration: duration,
                position: position
            }, TOAST_DEFAULTS[id]), {
                description: /*#__PURE__*/ React.createElement(React.Fragment, null, description || ((_TOAST_DEFAULTS_id = TOAST_DEFAULTS[id]) === null || _TOAST_DEFAULTS_id === void 0 ? void 0 : _TOAST_DEFAULTS_id.description), !!listItems.length && /*#__PURE__*/ React.createElement(ToastDescriptionList, _object_spread({
                    items: listItems
                }, listProps)))
            }), rest));
        }
    });
    return {
        toast: toast.current,
        TOASTS: TOASTS
    };
};
var ToastDescriptionList = function(_param) {
    var items = _param.items, rest = _object_without_properties(_param, [
        "items"
    ]);
    return /*#__PURE__*/ React.createElement(UnorderedList, rest, items.map(function(item, i) {
        return /*#__PURE__*/ React.createElement(ListItem, {
            key: i
        }, item);
    }));
};
var TOASTS = {
    PROJECT_NAME_UPDATED: 'PROJECT_NAME_UPDATED',
    PROJECT_INVALID: 'PROJECT_INVALID',
    PROJECT_SETTINGS_SAVED: 'PROJECT_SETTINGS_SAVED',
    INVALID_END_DATE: 'INVALID_END_DATE',
    NUM_RESPONDENTS_ERROR: 'NUM_RESPONDENTS_ERROR',
    ADD_PAYMENT_METHOD_FAILED: 'ADD_PAYMENT_METHOD_FAILED',
    SUBMIT_PAYMENT_FAILED: 'SUBMIT_PAYMENT_FAILED',
    COUNTRY_LANGUAGE_CHANGED: 'COUNTRY_LANGUAGE_CHANGED',
    WAVE_LAUNCHED_SUCCESS: 'WAVE_LAUNCHED_SUCCESS'
};
var TOAST_DEFAULTS = {
    PROJECT_NAME_UPDATED: {
        title: 'Project name updated.',
        status: 'success'
    },
    WAVE_LAUNCHED_SUCCESS: {
        title: 'Wave launched successfully.',
        status: 'success'
    },
    PROJECT_INVALID: {
        title: 'Errors found on project!',
        duration: 8000,
        isClosable: true,
        status: 'error'
    },
    PROJECT_SETTINGS_SAVED: {
        status: 'success',
        duration: 5000
    },
    INVALID_END_DATE: {
        status: 'error',
        duration: 3000,
        description: "You can't select an end date prior to the next possible launch date."
    },
    NUM_RESPONDENTS_ERROR: {
        status: 'error',
        description: 'Unable to update the number of respondents, please try again.'
    },
    ADD_PAYMENT_METHOD_FAILED: {
        status: 'error',
        duration: 3000
    },
    SUBMIT_PAYMENT_FAILED: {
        status: 'error',
        duration: 3000
    },
    COUNTRY_LANGUAGE_CHANGED: {
        status: 'success',
        duration: 5000,
        title: 'Project audience updated!',
        description: 'Your project country/language settings were updated successfully.'
    }
};
